export default __webpack_public_path__ + "static/media/page1Image4.9097b39b.jpg";